/* @jsx h */
import { defineComponent, h } from "vue";
import { useNativeBridge } from "@app/vue/providers/NativeBridge";

const SUPPORTED_EXTERNAL_SCHEMES = ["mailto:", "tel:"] as const;

function isSupportedExternalUrl(url: string): boolean {
  return SUPPORTED_EXTERNAL_SCHEMES.some((scheme) => url.startsWith(scheme));
}

export const ExternalLink = defineComponent({
  name: "ExternalLink",
  inheritAttrs: false,
  props: {
    href: {
      type: String,
      required: false,
    },
    target: {
      type: String,
      required: false,
    },
    rel: {
      type: String,
      required: false,
    },
  },
  setup(props, { attrs, slots }) {
    const bridge = useNativeBridge();

    const handleClick = async (event: MouseEvent) => {
      if (!props.href || !isSupportedExternalUrl(props.href) || !bridge) return;

      event.preventDefault();
      try {
        await bridge.rpc.request("openUrl", { url: props.href });
      } catch (error) {
        console.error("Failed to open external URL through native bridge:", error);
        window.location.href = props.href;
      }
    };

    return () => (
      <a {...attrs} href={props.href} target={props.target} rel={props.rel} onClick={handleClick}>
        {slots.default?.()}
      </a>
    );
  },
});
